import React from "react";
import "../css/style.css";
import { serverUrl } from "../_constants";
import confLogo from "../img/conf_logo.png";
import { confService } from "../_services";
import FormatIcons from '../_components/FormatIcons';
import onlineLogo from "../img/online.png";
import offlineLogo from "../img/offline.png";


export default function ConfItem(props) {

  const { data } = props;

  return (
    <li className="conf-list__item">
      <div className="card" onClick={props.onClick}>
        <div className="card__top" onClick={props.onEdit}>
            
          <img
            src={data.image ? serverUrl + data.image : confLogo}
            alt=""
            className="object-fit is--cover"
          />
          <div>
         {data.type == "offline" && (
            <span className="card__label"><span>
            оффлайн
            </span>
            <img style={{marginLeft:10}} src={offlineLogo} />
            </span>
          )}
          {data.type == "online" && (
            <span className="card__label">
            <span>
            онлайн
            </span>
            <img style={{marginLeft:10}} src={onlineLogo} />
            </span>
          )}
          {data.type == "hybrid" && (
            <span className="card__label">
          <span>
            гибридный
            </span>
            <img style={{marginLeft:10}} src={onlineLogo} />
            <img style={{marginLeft:10}} src={offlineLogo} />
            </span>
          )}
          </div>
        </div>

        <div className="card__body">
          <p style={{ marginBottom: 10, fontSize: 18, fontWeight: 500 }}>
            {data.name}
          </p>

          <p
            style={{
              marginBottom: 10,
              marginTop: 5,
              fontSize: 14,
              fontWeight: 500,
            }}
          >
            {data.is_published == 1 ? "Опубликована" : "Не опубликована"}
          </p>
          <div className="layout__inf">
            <ul className="layout__inf-list">
              <li className="layout__inf-item">
                <a onClick={props.onEdit} className="card__link">
                  <span>Редактировать</span>
                </a>
              </li>
              <li className="layout__inf-item">
                <a onClick={props.onDelete} className="card__link">
                  <span>Удалить</span>
                </a>
              </li>
            </ul>
          </div>

          <div className="layout__inf">
            <p className="layout__inf-text">
            {confService.getConfDateTimeStr(data.start_time,data.end_time)}
            </p>

            {!data.building_id && (
              <p className="layout__inf-text">Нет адреса</p>
            )}
            {data.building_id && (
              <p className="layout__inf-text">{data.building_id.address}</p>
            )}

            <ul className="layout__inf-blocks">
              <li className="layout__inf-block">
                <div className="layout__inf-media">
                  <svg width="24" height="24">
                    <use href="./img/sprite.svg#user-icon" />
                  </svg>

                  <p className="layout__inf-contains">
                    <strong>
                      {data.tickets_count ? data.tickets_count : "0"}
                    </strong>{" "}
                    <br />
                    участников
                  </p>
                </div>
              </li>

              <li className="layout__inf-block">
                <div className="layout__inf-media">
                  <svg width="24" height="24">
                    <use href="./img/sprite.svg#star-icon" />
                  </svg>

                  <p className="layout__inf-contains">
                    <strong>
                      {data.sponsors_count ? data.sponsors_count : "0"}
                    </strong>{" "}
                    <br />
                    спонсоров
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <a className="card__link" onClick={props.onSchedule}>
            <span>Расписание</span>
          </a>
        </div>
      </div>
    </li>
  );
}
